import { z } from "zod";
/**
 * Перечисления взаиморасчётов «Корпоративные клиенты» (контракт v2.0 §4.2, WP-DSP-2).
 */
export const zLedgerEntryType = z.enum(["CHARGE", "PAYMENT", "ADJUSTMENT", "REVERSAL"]);
export const LEDGER_ENTRY_TYPE_LABELS = {
    CHARGE: "Начисление",
    PAYMENT: "Оплата",
    ADJUSTMENT: "Корректировка",
    REVERSAL: "Сторно",
};
export const LEDGER_ENTRY_TYPE_COLORS = {
    CHARGE: "orange",
    PAYMENT: "green",
    ADJUSTMENT: "blue",
    REVERSAL: "red",
};
export const zLedgerEntryClass = z.enum(["BILLABLE", "MONEY"]);
export const zInvoiceStatus = z.enum(["ISSUED", "VOID"]);
export const INVOICE_VOID_LABEL = "Аннулирован";
export const INVOICE_STATUS_COLORS = {
    ISSUED: "blue",
    VOID: "default",
};
export const zPaymentState = z.enum(["UNPAID", "PARTIAL", "PAID"]);
export const PAYMENT_STATE_LABELS = {
    UNPAID: "Не оплачен",
    PARTIAL: "Оплачен частично",
    PAID: "Оплачен",
};
export const PAYMENT_STATE_COLORS = {
    UNPAID: "red",
    PARTIAL: "orange",
    PAID: "green",
};
